export default __webpack_public_path__ + "static/media/logo-blp.a207e862.svg";